import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_885_37691"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={14}
      height={14}
    >
      <rect width={14} height={14} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_885_37691)">
      <path
        d="M6.41797 9.33366H7.58464V7.58366H9.33463V6.41699H7.58464V4.66699H6.41797V6.41699H4.66797V7.58366H6.41797V9.33366ZM7.0013 12.8337C6.84575 12.8337 6.69748 12.8069 6.55651 12.7535C6.41554 12.7 6.29158 12.6149 6.18464 12.4982L1.53255 7.83158C1.42561 7.71491 1.33811 7.58609 1.27005 7.44512C1.202 7.30414 1.16797 7.15588 1.16797 7.00033C1.16797 6.84477 1.202 6.69651 1.27005 6.55553C1.33811 6.41456 1.42561 6.2906 1.53255 6.18366L6.18464 1.51699C6.3013 1.40033 6.42769 1.31283 6.5638 1.25449C6.69991 1.19616 6.84575 1.16699 7.0013 1.16699C7.15686 1.16699 7.30755 1.19616 7.45339 1.25449C7.59922 1.31283 7.72561 1.40033 7.83255 1.51699L12.4701 6.18366C12.577 6.30033 12.6645 6.42671 12.7326 6.56283C12.8006 6.69894 12.8346 6.84477 12.8346 7.00033C12.8346 7.15588 12.803 7.30414 12.7398 7.44512C12.6766 7.58609 12.5867 7.71491 12.4701 7.83158L7.83255 12.4982C7.72561 12.6052 7.59922 12.6878 7.45339 12.7462C7.30755 12.8045 7.15686 12.8337 7.0013 12.8337Z"
        fill="#7135BF"
      />
    </g>
  </svg>
);
export default SVGComponent;
